import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PortalUserVerificationNode } from '@app/services/api/api.types';

@Injectable({
  providedIn: 'root',
})
export class VerificationModalService {
  public activation$ = new Subject<{ email: string; activation: PortalUserVerificationNode }>();
  public verification$ = new Subject<void>();
  public verificationData: PortalUserVerificationNode | null;
  public verificationPassed = false;
  public verificationError: string = '';
  public portalLink = '';

  public showModal(verificationData: PortalUserVerificationNode, portalLink = ''): void {
    this.verificationData = verificationData;
    this.portalLink = portalLink;
    this.verification$.next();
  }

  public setVerificationPassed(verificationPassed: boolean): void {
    this.verificationPassed = verificationPassed;
  }

  public setVerificationError(verificationError: string): void {
    this.verificationError = verificationError;
  }
}
